import { TenantSwitchingState } from "./tenant-switching.state";
import { TenantInfo } from "../models/tenant.model";
import { SimpleSelectOption } from "../shared/components/simple-select/simple.select.component";

// Basic selectors
export function selectAvailableTenants(state: TenantSwitchingState): TenantInfo[] {
  return state.availableTenants;
}

export function selectSelectedTenantId(state: TenantSwitchingState): string | null {
  return state.selectedTenantId;
}

export function selectSelectedTenant(state: TenantSwitchingState): TenantInfo | null {
  if (!state.selectedTenantId) {
    return null;
  }
  return state.availableTenants.find(tenant => tenant.tenantId === state.selectedTenantId) ?? null;
}

export function selectTenantSwitchingLoading(state: TenantSwitchingState): boolean {
  return state.loading;
}

export function selectTenantSwitchingError(state: TenantSwitchingState): string | null {
  return state.error;
}

export function selectIsSwitching(state: TenantSwitchingState): boolean {
  return state.isSwitching;
}

// Complex selectors
export function selectTenantOptions(state: TenantSwitchingState): SimpleSelectOption[] {
  return state.availableTenants.map(tenant => ({
    value: tenant.tenantId,
    label: tenant.title,
    // disabled: !tenant.active
    disabled: false
  }));
}

export function selectHasMultipleTenants(state: TenantSwitchingState): boolean {
  return state.availableTenants.length > 1;
}

export function selectCanSwitchTenants(state: TenantSwitchingState): boolean {
  return state.availableTenants.length > 1 && !state.isSwitching && !state.loading;
}
